import { __assign } from "tslib";
import React from 'react';
import { BarChartWidget, LineChartWidget, AreaChartWidget, PieChartWidget, DonutChartWidget, MetricChartWidget, FunnelChartWidget, HeatmapChartWidget, ChoroplethChartWidget, BubbleChartWidget, GaugeChartWidget, TableChartWidget, } from '@keen.io/widgets';
import { KEEN_KEY, KEEN_ELEMENTS } from '@keen.io/parser';
export var renderWidget = function (_a) {
    var type = _a.type, keys = _a.keys, data = _a.data, componentSettings = _a.componentSettings, widgetSettings = _a.widgetSettings, legend = _a.legend, eventBus = _a.eventBus, inEditMode = _a.inEditMode;
    var chartSettings = __assign({ keys: keys,
        data: data, labelSelector: KEEN_KEY }, componentSettings);
    switch (type) {
        case 'bubble':
            return (React.createElement(BubbleChartWidget, __assign({ legend: legend }, chartSettings, widgetSettings)));
        case 'choropleth':
            return (React.createElement(ChoroplethChartWidget, __assign({ legend: legend, elementsKey: KEEN_ELEMENTS }, chartSettings, widgetSettings)));
        case 'gauge':
            return (React.createElement(GaugeChartWidget, __assign({ legend: legend }, chartSettings, widgetSettings)));
        case 'funnel':
            return (React.createElement(FunnelChartWidget, __assign({ legend: legend }, chartSettings, widgetSettings)));
        case 'metric':
            return (React.createElement(MetricChartWidget, __assign({}, chartSettings, widgetSettings)));
        case 'pie':
            return (React.createElement(PieChartWidget, __assign({ legend: legend }, chartSettings, widgetSettings)));
        case 'donut':
            return (React.createElement(DonutChartWidget, __assign({ legend: legend }, chartSettings, widgetSettings)));
        case 'table':
            return (React.createElement(TableChartWidget, __assign({ inEditMode: inEditMode, eventBus: eventBus }, chartSettings, widgetSettings)));
        case 'bar':
            return (React.createElement(BarChartWidget, __assign({ legend: legend }, chartSettings, widgetSettings)));
        case 'heatmap':
            return (React.createElement(HeatmapChartWidget, __assign({ legend: legend }, chartSettings, widgetSettings)));
        case 'line':
            return (React.createElement(LineChartWidget, __assign({ legend: legend }, chartSettings, widgetSettings)));
        case 'area':
            return (React.createElement(AreaChartWidget, __assign({ legend: legend }, chartSettings, widgetSettings)));
    }
};
